var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.959 11.815 c -0.426 0.279 -0.962 0.312 -1.45 0.46 c -0.487 0.149 -0.993 0.512 -0.993 1.022 c 0 0.385 0.304 0.717 0.657 0.87 c 0.353 0.153 0.75 0.163 1.135 0.171 c 0.669 0.014 1.338 0.028 2.008 0.042 c 0.344 0.007 0.703 0.011 1.011 -0.143 c 0.654 -0.329 0.787 -1.188 0.838 -1.918 c 0.046 -0.662 0.092 -1.337 -0.066 -1.982 c -0.221 -0.906 -1.019 -1.918 -1.833 -1.028 C 26.613 10.021 26.878 11.214 25.959 11.815 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.873 76.13 c -0.11 0.079 -0.225 0.159 -0.293 0.277 c -0.124 0.216 -0.052 0.492 0.07 0.709 c 0.558 0.989 1.9 1.186 3.03 1.069 c 0.316 -0.033 0.639 -0.084 0.917 -0.238 c 0.298 -0.166 0.522 -0.437 0.727 -0.71 c 1.539 -2.059 2.387 -4.626 2.376 -7.196 c -0.001 -0.168 -0.016 -0.359 -0.147 -0.463 c -0.135 -0.108 -0.332 -0.075 -0.498 -0.026 c -1.473 0.435 -2.303 1.429 -2.947 2.717 C 60.344 73.794 59.266 75.131 57.873 76.13 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.198 81.515 c -9.114 -5.703 -15.939 -14.723 -18.785 -25.37 l 0.001 0 c 4.422 2.13 6.314 5.794 10.926 7.474 c 2.324 0.846 4.802 1.725 6.335 3.667 c 1.649 2.088 1.84 5.039 1.145 7.607 s 1.828 4.387 0.38 6.619 L 22.198 81.515 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 1.957 c -1.308 0 -2.602 0.058 -3.88 0.172 l 0 0.001 c -1.452 1.538 -5.154 2.131 -6.381 4.74 c -0.195 0.415 -0.397 0.851 -0.369 1.308 c 0.039 0.621 0.512 1.15 1.072 1.42 c 0.56 0.27 1.198 0.325 1.819 0.345 c 0.477 0.016 0.959 0.013 1.427 -0.082 c 0.741 -0.15 1.064 -0.761 1.581 -1.313 c 0.355 -0.698 1.321 -2.451 1.817 -3.058 c 1.155 -1.412 0.531 -0.578 3.201 -0.555 l 0.001 0.979 c -1.142 2.131 -1.939 2.698 -2.315 4.36 c -0.223 0.984 -0.468 2.014 -1.14 2.767 c -0.752 0.843 -4.06 0.115 -5.172 0.313 c -2.268 0.405 -2.533 1.55 -4.776 1.027 c 0.13 3.145 0.025 2.057 -1.116 4.991 c -1.625 0.085 -4.307 0.509 -5.763 1.235 c -0.674 0.337 -0.293 2.958 -0.488 3.685 c -0.187 0.698 0.165 1.46 0.726 1.917 c 0.56 0.456 1.291 0.65 2.009 0.731 c 1.748 0.196 3.56 -0.231 5.036 -1.188 c 0.964 -0.625 1.79 -1.467 2.823 -1.97 c 1.033 -0.503 3.602 -0.87 4.393 -0.037 c 0.876 0.922 0.542 4.159 1.773 4.477 c 0.981 0.253 0.955 -1.859 1.461 -2.736 c 0.507 -0.877 1.195 -1.908 2.205 -1.84 c 0.472 0.032 0.888 0.313 1.25 0.617 c 1.139 0.956 0.663 3.816 2.148 3.757 c 0.805 -0.032 2.202 -1.178 3.224 -2.224 c 0.634 0.728 -1.253 4.197 -0.34 4.504 c 0.921 0.309 5.984 -1.639 6.612 -0.897 c 0.173 0.204 0.336 0.434 0.371 0.699 c 0.074 0.564 -0.439 1.025 -0.932 1.31 c -1.833 1.06 -3.162 1.522 -5.072 2.436 c -7.951 3.805 -10.871 -3.857 -23.332 -4.253 c -3.922 0.83 -3.226 2.448 -5.403 4.101 c -1.475 1.12 -1.977 2.079 -2.804 3.735 c -1.404 2.809 -0.443 6.218 0.965 9.025 c 0.968 1.931 2.219 3.84 4.117 4.873 c 1.008 0.549 2.14 0.818 3.257 1.081 c 1.682 0.396 3.364 0.793 5.046 1.189 c 0.714 0.168 1.455 0.349 2.024 0.812 c 0.595 0.484 0.926 1.212 1.237 1.913 c 0.667 1.506 1.339 3.023 1.718 4.627 c 0.319 1.348 0.429 2.743 0.822 4.071 c 0.809 2.728 2.759 8.225 3.641 10.931 c 0.219 0.671 0.374 1.373 0.724 1.986 c 0.423 0.741 1.119 1.31 1.907 1.637 c 1.503 0.622 3.259 0.358 4.722 -0.352 s 2.687 -5.052 3.862 -6.177 c 3.565 -3.416 7.031 -7.37 7.897 -12.231 c 0.211 -1.184 0.282 -2.456 0.972 -3.441 c 0.68 -0.97 1.828 -1.473 2.787 -2.169 c 1.185 -0.86 2.117 -2.065 2.651 -3.429 c 0.269 -0.688 0.439 -1.453 0.235 -2.163 c -0.461 -1.607 -2.426 -2.099 -3.894 -2.897 c 2.932 -1.615 6.818 -2.499 9.75 -4.113 c 0.698 -0.384 1.407 -0.777 1.962 -1.349 c 0.249 -0.257 0.475 -0.581 0.458 -0.939 c -0.011 -0.229 -0.12 -0.44 -0.227 -0.642 c -0.713 -1.341 -1.371 -1.319 -2.16 -2.617 l -0.006 -0.016 c 0.665 0.04 1.332 0.05 1.995 0.005 c 1.762 -0.12 3.808 -0.405 5.047 0.855 c 1.115 1.134 0.983 2.94 1.102 4.526 c 0.142 1.885 0.784 3.781 2.074 5.163 c 1.291 1.382 0.472 3.547 2.314 3.118 l 0.003 0 c 0.247 -1.866 0.375 -3.771 0.375 -5.705 C 88.043 21.228 68.772 1.957 45 1.957 z M 56.059 26.232 c -1.092 -0.054 -3.51 -0.931 -4.489 -0.441 c 0.488 -0.5 0.891 -0.977 1.101 -1.3 c 0.651 -0.998 1.204 -2.126 2.2 -2.78 c 1.168 -0.767 2.719 -0.705 4.035 -0.234 c 0.933 0.334 1.882 0.972 2.067 1.946 c 0.204 1.076 -0.651 2.122 -1.668 2.529 C 58.287 26.358 57.152 26.286 56.059 26.232 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -8.459 0 -16.703 -2.361 -23.839 -6.827 C 11.444 77.092 4.47 67.673 1.523 56.65 C 0.513 52.868 0 48.948 0 45 C 0 21.534 17.602 2.266 40.945 0.18 C 42.284 0.061 43.648 0 45 0 c 24.813 0 45 20.187 45 45 c 0 1.989 -0.132 3.995 -0.392 5.96 C 86.662 73.217 67.485 90 45 90 z M 45 3.913 c -1.236 0 -2.483 0.055 -3.707 0.165 C 19.983 5.982 3.913 23.575 3.913 45 c 0 3.607 0.468 7.187 1.39 10.64 c 2.69 10.063 9.059 18.663 17.933 24.217 C 29.75 83.933 37.276 86.087 45 86.087 c 20.529 0 38.039 -15.322 40.73 -35.64 c 0.237 -1.796 0.357 -3.628 0.357 -5.447 C 86.087 22.345 67.656 3.913 45 3.913 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.41644ac1.svg";
export { ForwardRef as ReactComponent };